import i18n from "lib/i18n";
import { template } from "lodash";
import { View } from "backbone";
import Comment from "models/comment";
import { currentUser } from "lib/currentUser";
import { wrapInUserModel } from "models/user";
/* eslint-disable
    camelcase,
    func-names,
    no-multi-assign,
    no-return-assign,
    no-shadow,
    no-undef,
    no-underscore-dangle,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
let CommentPreviewView;

export default CommentPreviewView = (function () {
  CommentPreviewView = class CommentPreviewView extends View {
    static initClass() {
      this.prototype.tagName = "li";
      this.prototype.className = "comment-view";

      this.prototype.template = template(`\
<article class="comment preview">
  <header class="meta">
    <div class="preview-message"><%= i18n.t('comment.messages.preview_comment') %></div>
    <section class="attribution author-avatar">
      <img class="comment avatar" height="36" width="36" src="<%- user_avatar_url %>" alt="">
      <h3 class="fn">
        <% if (user_profile_url) { %>
          <a href="<%- user_profile_url %>"><%- user_full_name %></a>
        <% } else { %>
          <%- user_full_name %>
        <% } %>
        <% if (user_friend_of_tc) { %>
          <a href="<%- this._donationUrl() %>" class="friend-of-the-conversation-badge">
            <span>
              <div class="hover tooltip bottom">
                <%-i18n.t('comment.label.friend_of_the_conversation', { name: user_full_name}) %>
              </div>
            </span>
          </a>
        <% } %>
      </h3>
      <p>
        <% if (institution_name && institution_path) { %>
          <% if (user_occupation) { %>
            <%- user_occupation %>,
          <% } %>

          <a href="<%- institution_path %>"><%- institution_name %></a>
        <% } else { %>
          <%- user_occupation %>
        <% } %>
      </p>
    </section>
  </header>
  <section class="comment-body">
    <div class="full-comment"><%= full_body %></div>
  </section>
</article>\
`, { imports: { i18n } });
    }

    initialize(options) {
      super.initialize(options);

      if (options.comment) {
        this.model = new Comment(options.comment);
      }

      this.render();
    }

    async render() {
      const custom_donation_url = await this._donationUrl();
      const attributes = { custom_donation_url, ...this.model.attributes };
      return this.el.innerHTML = this.template(attributes);
    }

    async _donationUrl() {
      const url = this.model.get("donation_url");
      const user = await currentUser().then(wrapInUserModel);

      if (user.exists()) {
        return `${url}&user_id=${user.get("id")}`;
      }
      return url;
    }
  };
  CommentPreviewView.initClass();
  return CommentPreviewView;
}());
